import React from 'react';

export const Card = ({ height }: { height: number }) => {
  return (
    <div style={{ boxShadow: '0 2px 8px rgba(33, 37, 51, 0.06)' }}>
      <div className={`bg-[#e7e7e7] rounded-t-8`} style={{ height: height }} />
      <div className="px-24 pt-16 pb-[82px] rounded-b-8">
        <div className="h-[14px] bg-[#e7e7e7] w-full mb-8" />
        <div className="h-[14px] bg-[#e7e7e7] w-full mb-8" />
        <div className="h-[14px] bg-[#e7e7e7] w-1/2 mb-8" />
      </div>
    </div>
  );
};
